/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import BaseControl from 'scripts/base-control';
import appContext from 'scripts/app-context';
import scheduleDataView from './streaming-schedule.stache';
import 'components/right-rail/streaming-schedule/streaming-schedule';

export const RightRailStreamingSchedule = BaseControl.extend({
    init: function () {
        this._super();

        appContext.model.bind('on-streaming-schedule-data', this.onStreamingScheduleData.bind(this));
        this.$element.find('.js-schedule-container').prepend(scheduleDataView());
    },

    onStreamingScheduleData: function (ev, data) {
        if (data){
            this.$element
                .toggle(true)
                .find('.js-schedule-day').html(data.dayOfWeek)
        } else {
            this.$element
                .toggle(false)
        }
    }
});
